<div class="container dialog-container d-flex flex-wrap">
  <form class="k-form w-100" #editAddressForm="ngForm" novalidate>
    <div class="m-2">
      <kendo-label for="line1Input" text="Line 1">
      </kendo-label>
      <kendo-textbox id="line1Input" name="line1Input" [(ngModel)]="value.formattedAddress.line1">
      </kendo-textbox>
    </div>

    <div class="m-2">
      <kendo-label for="line2Input" text="Line 2">
      </kendo-label>
      <kendo-textbox id="line2Input" name="line2Input" [(ngModel)]="value.formattedAddress.line2">
      </kendo-textbox>
    </div>

    <div class="m-2">
      <kendo-label for="line3Input" text="Line 3">
      </kendo-label>
      <kendo-textbox id="line3Input" name="line3Input" [(ngModel)]="value.formattedAddress.line3">
      </kendo-textbox>
    </div>

    <div class="m-2">
      <kendo-label for="townInput" text="Town or City">
      </kendo-label>
      <kendo-textbox id="townInput" name="townInput" [(ngModel)]="value.formattedAddress.suburb">
      </kendo-textbox>
    </div>

    <div class="m-2">
      <kendo-label for="stateInput" text="State or Region">
      </kendo-label>
      <kendo-textbox id="stateInput" name="stateInput" [(ngModel)]="value.formattedAddress.state">
      </kendo-textbox>
    </div>

    <div class="m-2">
      <kendo-label for="postcodeInput" text="Postcode">
      </kendo-label>
      <kendo-textbox id="postcodeInput" name="postcodeInput" [(ngModel)]="value.formattedAddress.postcode">
      </kendo-textbox>
    </div>

    <div class="m-2">
      <kendo-label for="countryInput" text="Country">
      </kendo-label>
      <kendo-combobox [data]="countries" id="countryInput" name="countryInput" [(ngModel)]="value.formattedAddress.country">
      </kendo-combobox>
    </div>
  </form>

  <div class="d-flex flex-row-reverse mt-4 w-100">
    <button class="ms-2" kendoButton [primary]="true" type="button" (click)="onOkClick()">
      Ok
    </button>
    <button kendoButton type="button" (click)="onCancelClick()">
      Cancel
    </button>
  </div>
</div>